import React, { useEffect, useState } from "react";
import {
  Button,
  EmployeeHeader,
  NewTab,
  PageHeader,
  PageTab,
} from "../../../../components";
import Paymentsdashboard from "./Payments/Paymentsdashboard";
import Creditbalancedashboard from "./Payments/Creditbalancedashboard";
import Payconfigurations from "./Payments/Payconfigurations";
import Adjustments from "./Payments/Adjustments";
import Deduction from "./Payments/Deduction";
import Previouspaydetails from "./Payments/Previouspaydetails";
import Otherpayment from "./Payments/Otherpayment";
import MiscellaneuousPayments from "./Payments/MiscellaneuousPayments";
import Advancepay from "./Payments/Advancepay";
import UnpaidTimesheet from "./Payments/UnpaidTimesheet";
import { useDispatch, useSelector } from "react-redux";
import { restrictedMenuIds } from "../../../../assets/data/enumData";
import BonusPayments from "./Payments/BonusPayments";
import { clearPlacementsData } from "../../../../redux/slices/placements/placementsSlice";
import { useNavigate } from "react-router-dom";

const Payments = () => {
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    error,
    employees,
    totalCount,
  } = useSelector((state) => state.employee);
  const employmentType = employeeDetails?.employmentType;
  const navigate = useNavigate();
  console.log("employmentType", employmentType);
  console.log("currentEmployee", employeeDetails);
  // const [activeTab, setActiveTab] = useState(0);
  const DocumentsMenus = [
    {
      title: "Pay Data Dashboard",
      page: <Paymentsdashboard />,
      type: "main",
    },
    // {
    //   title: "Credit Balance Dashboard",
    //   page: <Creditbalancedashboard />,
    //   type: "main",
    // },
    {
      title: "Pay Configuration",
      page: <Payconfigurations />,
      type: "main",
    },
    {
      title: "Adjustments",
      page: <Adjustments />,
      type: "main",
    },
    {
      title: "Deductions",
      page: <Deduction />,
      type: "main",
    },
    {
      title: "Other Payment",
      page: <Otherpayment />,
      type: "main",
    },

    {
      title: "Previous Pay Details",
      page: <Previouspaydetails />,
      type: "main",
    },
    {
      title: "Unpaid Timesheet",
      page: <UnpaidTimesheet />,
      type: "main",
    },
    {
      title: "Bonus Payments",
      page: <BonusPayments />,
      type: "main",
    },
    //    {
    //   title: "Advance Pay",
    //   page: <Advancepay />,
    //   type: "main",
    // },

    // {
    //   title: "Miscellaneuous Payments",
    //   page: <MiscellaneuousPayments />,
    //   type: "main",
    // },
  ];

  // Final filtered menu
  const filteredDocumentsMenus =
    employmentType === 2 || employmentType === 3
      ? DocumentsMenus.filter((item) => !restrictedMenuIds.includes(item.title))
      : DocumentsMenus;
  return (
    <div className="mt-3 flex-1 flex flex-col gap-2 overflow-hidden">
      <div>
        <PageHeader
          Section={<EmployeeHeader />}
          RightSection={
            <div className="flex gap-3">
              <Button
                color="primary"
                size="sm"
                title={"Back"}
                icon={"west"}
                type="link"
                to="/employee"
              />
              {/* <Button
                size="sm"
                title={"Back"}
                icon={"west"}
                // onClick={() =>
                //   navigate("/employee/employee-profile#timesheets")
                // }
                onClick={() =>
                  navigate(
                    "/employee/employee-profile?profile-info=timesheets&timesheets=timesheets",
                  )
                }
              /> */}
              {/* <Button
                size="sm"
                title={"Next"}
                icon={"east"}
                iconPosition="after"
                //onClick={() => navigate("/employee/employee-profile#invoices")}
                onClick={() =>
                  navigate("/employee/employee-profile?profile-info=invoices")
                }
              /> */}
            </div>
          }
        />
      </div>
      <div className=" flex-1 flex overflow-hidden">
        <NewTab
          tabs={filteredDocumentsMenus}
          color="black"
          variant="outlined"
          //mainTabsShow={"5"}
          mode="url"
          tabId="payments"
        />
      </div>
    </div>
  );
};

export default Payments;
